package com.vamvisions.main.contact.presentation

import com.vamvisions.main.contact.domain.model.ContactTopic
import com.vamvisions.main.core.presentation.i18n.UiText

/**
 * The contact form. [topic] is the optional choice of what the message is about. A field's error is set when Send finds it invalid, and is cleared once the field is corrected.
 * [invalidSendCount] grows on every Send blocked by an invalid field, so the page can move focus to the first one.
 */
data class ContactState(
    val name: String = "",
    val email: String = "",
    val message: String = "",
    val topic: ContactTopic? = null,
    val website: String = "",
    val nameError: UiText? = null,
    val emailError: UiText? = null,
    val messageError: UiText? = null,
    val isSending: Boolean = false,
    val result: ContactResult? = null,
    val invalidSendCount: Int = 0,
)

/** The outcome of the last send, announced to the user. */
sealed interface ContactResult {
    data object Sent : ContactResult
    data class Failed(val error: UiText) : ContactResult
}
